import React from 'react'

const Ptn = ({
    isScrolled
}) => {
    return (
        <div>
            <div className={`xs:hidden lg:block fixed top-0 left-0 bgPtn w-full h-screen z-[100] mix-blend-multiply`} />
            <div className={`xs:block lg:hidden fixed top-0 left-0 bgPtn w-full h-screen z-[100] mix-blend-multiply mask-gradient2  ${isScrolled ? "opacity-0" : "opacity-100"}`} />
            <div
                className={`xs:block lg:hidden fixed top-0 left-0 bgPtn w-full h-screen z-[100] mix-blend-multiply transition-opacity duration-700 ${isScrolled ? "opacity-100 mask-gradient" : "opacity-0 mask-gradient"}`}
            />
        </div>
    )
}

export default Ptn